module.exports = __webpack_public_path__ + "img/icon6.a1e82f6a.png";